(() => {
    const menuTrigger = document.getElementsByClassName('menu-trigger');
    const navDiv = document.getElementsByClassName('nav-menu');
    menuTrigger[0].addEventListener('click', function (e) {
        e.preventDefault();
        if (e.target.getAttribute('class').indexOf('open') !== -1) {
            e.target.setAttribute('class', 'menu-trigger');
            navDiv[0].setAttribute('class', 'nav-menu');
        } else {
            e.target.setAttribute('class', 'menu-trigger open');
            navDiv[0].setAttribute('class', 'nav-menu open');
        }
    });
})();
